import request from '@/middleware/request'

const getImage = data => {
  return request({
    url: '/images/list',
    method: 'post',
    data
  })
}

const getImageCategory = () => {
  return request({
    url: '/images/category',
    method: 'get'
  })
}

const updateImage = (id, data) => {
  return request({
    url: `/images/${id}`,
    method: 'put',
    data
  })
}

const deleteImage = id => {
  return request({
    url: `/images/${id}`,
    method: 'delete'
  })
}

const uploadFileImage = formData => {
  return request({
    url: `/images/file/upload`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export default {
  getImage,
  getImageCategory,
  uploadFileImage,
  updateImage,
  deleteImage
}
